import { mapValues } from 'lodash';
import createFlags from 'flag';
import { createReduxBindings } from 'flag/redux';

export type FlagOverride = {
  default: boolean;
  overrideUsers?: string[];
  overrideGroups?: string[];
};

export type FlagValue = boolean | FlagOverride;

export type AppFlagsConfig = {
  features: {
    queues: FlagValue;
    manage: FlagValue;
    search: FlagValue;
    diffViewer: FlagValue;
    amplitude: FlagValue;
  };
  layout: {
    dragAndDrop: FlagValue;
  };
};

export type AppFlags = {
  features: {
    queues: boolean;
    manage: boolean;
    search: boolean;
    diffViewer: boolean;
    amplitude: boolean;
  };
  layout: {
    dragAndDrop: boolean;
  };
};

export function resolveDefaultFlags(flagsConfig: AppFlagsConfig): AppFlags {
  return mapValues(flagsConfig, section =>
    mapValues(section, (flag: FlagValue) =>
      typeof flag === 'boolean' ? flag : flag.default,
    ),
  ) as AppFlags;
}

const { FlagsProvider, Flag, useFlag, useFlags } = createFlags<AppFlags>();

export { FlagsProvider, Flag, useFlag, useFlags };

const {
  setFlagsAction,
  getFlagsSelector,
  createFlagsReducer,
  ConnectedFlagsProvider,
} = createReduxBindings(FlagsProvider);

export {
  setFlagsAction,
  getFlagsSelector,
  createFlagsReducer,
  ConnectedFlagsProvider,
};
